module.exports = __webpack_public_path__ + "img/icon-play.ea2411f7.svg";